import BeId from './BeId';

export default BeId;
